var map = {
	"./decidim/avatar-multiuser.png": 47320,
	"./decidim/brands/facebook.svg": 46534,
	"./decidim/brands/google.svg": 76775,
	"./decidim/brands/twitter-x.svg": 29548,
	"./decidim/cc-badge.png": 36882,
	"./decidim/decidim-logo.svg": 38138,
	"./decidim/default-avatar.svg": 93478,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 43674,
	"./decidim/icons.svg": 68297,
	"./decidim/pattern.png": 97382,
	"./decidim/placeholder-card-g.svg": 16395,
	"./decidim/placeholder-card-l.svg": 67424,
	"./decidim/placeholder.jpg": 27495,
	"./decidim/remixicon.symbol.svg": 36255,
	"./decidim/vendor/social-share-button/douban.svg": 67598,
	"./decidim/vendor/social-share-button/email.svg": 52267,
	"./decidim/vendor/social-share-button/facebook.svg": 99629,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 68215,
	"./decidim/vendor/social-share-button/hacker_news.svg": 5583,
	"./decidim/vendor/social-share-button/linkedin.svg": 86707,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 2556,
	"./decidim/vendor/social-share-button/pinterest.svg": 94781,
	"./decidim/vendor/social-share-button/reddit.svg": 54189,
	"./decidim/vendor/social-share-button/telegram.svg": 35988,
	"./decidim/vendor/social-share-button/tumblr.svg": 12699,
	"./decidim/vendor/social-share-button/twitter.svg": 69098,
	"./decidim/vendor/social-share-button/vkontakte.svg": 53204,
	"./decidim/vendor/social-share-button/wechat.svg": 44783,
	"./decidim/vendor/social-share-button/whatsapp.svg": 35791,
	"./decidim/vendor/social-share-button/x.svg": 34763,
	"./decidim/vendor/social-share-button/xing.svg": 94461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63349;